'use strict';

module.exports = function(items) {
    for(let i = 0; i < items.length; i++) {
        for(let j = 0; j < items.length - 1 - i; j++) {
            if(items[j].pos > items[j+1].pos) {
                let temp = items[j+1];
                items[j+1] = items[j];
                items[j] = temp;
            }
        }
    }
    return items;
};
